import { QueryClient } from '@tanstack/react-query';
import { queryClientCacheTime, queryClientStaleTime } from './queryConsts';

/**
 * Settings for React Query Client.
 */
export const appQueryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: queryClientStaleTime,
            cacheTime: queryClientCacheTime,
            retry: 1,
            refetchOnWindowFocus: false
        }
    }
});
